module.exports = __webpack_public_path__ + "static/media/ruby.d34e79c5.svg";